/* VSUAL — Agregar al carrito sin recargar

   Cualquier formulario con [data-vsual-add] agrega por AJAX y avisa al tema
   base, que abre su propio cajón del carrito con la barra de envío gratis y el
   cross-sell ya armados. Reimplementar ese cajón sería duplicar algo que la
   tienda ya tiene funcionando.

   Si algo falla —fetch no disponible, respuesta con error— se deja que el
   formulario se envíe como siempre. Vale más un agregado que recarga la página
   que un botón que no hace nada. */
(function () {
  'use strict';

  function avisarAlTema() {
    // El tema base escucha uno u otro segun la version; se emiten los dos.
    ['cart:refresh', 'cart:updated'].forEach(function (evt) {
      document.dispatchEvent(new CustomEvent(evt, { bubbles: true }));
    });
  }

  function initForm(form) {
    if (form.dataset.vsualBound === 'true') return;
    form.dataset.vsualBound = 'true';

    var btn = form.querySelector('[type="submit"]');
    if (!btn || !window.fetch) return;

    var etiquetaOriginal = btn.textContent;
    var ocupado = false;

    form.addEventListener('submit', function (e) {
      if (ocupado) { e.preventDefault(); return; }
      e.preventDefault();
      ocupado = true;

      btn.disabled = true;
      btn.textContent = btn.dataset.labelLoading || etiquetaOriginal;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function () {
          btn.textContent = btn.dataset.labelDone || etiquetaOriginal;
          avisarAlTema();
          setTimeout(function () {
            btn.textContent = etiquetaOriginal;
            btn.disabled = false;
            ocupado = false;
          }, 1800);
        })
        .catch(function () {
          // Se devuelve el control y se manda el formulario como siempre.
          form.dataset.vsualBound = 'false';
          btn.disabled = false;
          btn.textContent = etiquetaOriginal;
          ocupado = false;
          form.submit();
        });
    });
  }

  function initAll() {
    document.querySelectorAll('form[data-vsual-add]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
